"use client";

import { useState, type ReactNode } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/app/components/ui/button";
import { cn } from "@/lib/utils";

type ContactPersonFilterTogglePropsT = {
  search: ReactNode;
  reset: ReactNode;
  filters: ReactNode;
};

export default function ContactPersonFilterToggle({
  search,
  reset,
  filters,
}: ContactPersonFilterTogglePropsT) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
        {search}
        <div className="flex w-full flex-col gap-2 sm:ml-auto sm:w-auto sm:flex-row">
          <Button
            type="button"
            variant="secondary"
            className="w-full sm:hidden"
            aria-expanded={isOpen}
            aria-controls="contact-person-filters"
            onClick={() => setIsOpen((current) => !current)}
          >
            <SlidersHorizontal className="size-4" strokeWidth={1.75} />
            {isOpen ? "Filter ausblenden" : "Filter anzeigen"}
          </Button>
          {reset}
        </div>
      </div>

      <div
        id="contact-person-filters"
        className={cn(
          "overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out sm:max-h-none sm:overflow-visible sm:opacity-100",
          isOpen ? "max-h-[1200px] opacity-100" : "max-h-0 opacity-0"
        )}
      >
        {filters}
      </div>
    </>
  );
}
